import { render, staticRenderFns } from "./CreateWheelLock.vue?vue&type=template&id=35c3f4ef&"
import script from "./CreateWheelLock.vue?vue&type=script&lang=js&"
export * from "./CreateWheelLock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports